import $api from "@/frontend/shared/api/axios";
import { convertStringWithAndSymbol } from "@/frontend/shared/lib/convertStringWithAndSymbol/convertStringWithAndSymbol";
import { ESectionOptions } from "@/frontend/widgets/Sidebar";

export async function postCompanySectionNote({ content, companyId }: { content: string; companyId: number }) {
  const section = ESectionOptions.OVERVIEW;
  const sectionWithoutSpaces = convertStringWithAndSymbol(section);
  const response = await $api.post(`/companies/${companyId}/notes`, { section: sectionWithoutSpaces, content });
  return response;
}
